import { ToastNotifications } from '@karnov/kui-react'
import { AnimatePresence, motion } from 'motion/react'
import toast from 'react-hot-toast/headless'

import { cn } from './cn'

type Input = Omit<Parameters<typeof ToastNotifications>[0], 'onClose'> & {
  onClose?: VoidFunction
  duration?: number
  closeOnClick?: boolean
}

export const triggerToastNotification = (options: Input): void => {
  const {
    message,
    variant,
    onUndo,
    onClose,
    hasIcon,
    undoLabel,
    hideCloseButton = false,
    duration,
    closeOnClick = false,
  } = options

  toast.custom(
    t => (
      <AnimatePresence>
        {t.visible && (
          <motion.div
            key={t.id}
            initial={{ opacity: 0, y: -400 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{
              opacity: 0,
              scale: 0,
              transition: { opacity: { duration: 0.15 } },
            }}
            transition={{
              bounce: 0.14,
              duration: 1.1,
              type: 'spring',
            }}
            onClick={closeOnClick
              ? () => {
                  toast.dismiss(t.id)
                  onClose?.()
                }
              : undefined}
            className={cn('print:hidden', { 'cursor-pointer': closeOnClick })}
          >
            <ToastNotifications
              variant={variant}
              message={message}
              onUndo={onUndo}
              onClose={() => toast.dismiss(t.id)}
              hideCloseButton={hideCloseButton}
              hasIcon={hasIcon}
              undoLabel={undoLabel}
            />
          </motion.div>
        )}
      </AnimatePresence>
    ),
    { duration },
  )
}
